import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-charge-list-view',
  imports: [],
  templateUrl: './charge.list-view.html',
  styleUrls: ['./charge.list-view.css'],
})
export class ChargeListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
